const NotFound = () => {
    return ''
}

export default NotFound;
